import { Component, OnInit, HostListener } from '@angular/core';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { isUndefined } from "util";

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  notSupportedSize : boolean;
  paymentMethods = [
    { "imageURL" : 'card_pay',  "tag" : 'Card'  },
    { "imageURL" : 'banking_pay',  "tag" : 'Netbanking'  },
    { "imageURL" : 'wallet_pay',  "tag" : 'Wallet'  },
    { "imageURL" : 'upi_pay',  "tag" : 'UPI'  },
    { "imageURL" : 'qr_pay',  "tag" : 'QR'  }
  ];
  rightPanel:any;
  phoneEmpty:any;
  mobileNo:any;
  emailEmpty:any;
  email:any;

  constructor(private restApiService:RestApiService) {
    if (window.screen.width < 900) {
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }
   }

  ngOnInit() {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
    // event.target.innerWidth;

  }


}



// WEBPACK FOOTER //
// ./src/app/payment/payment.component.ts